import React from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import { injectIntl } from "react-intl";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Chip from "@material-ui/core/Chip";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import styles from "../../CenterBrandPage/centerbrandpage-jss";
import cookie from "react-cookies";
import DatePicker, { registerLocale } from "react-datepicker";
import tr from "date-fns/locale/tr";
import "../datepicker.css";
import moment from "moment";
import {
  getBonusRules,
  setBonusRule,
  updateFormData,
  resetFormData,
  getRegionsList,
  toggleBonusRuleStatus,
  deleteBonusRule,
} from "../../../../redux/modules/BonusRuleReducer";

// Register Turkish locale
registerLocale("tr", tr);

// Get today's and tomorrow's dates in YYYY-MM-DD format
const today = new Date();
const tomorrow = new Date(today);
tomorrow.setDate(tomorrow.getDate() + 1);

const todayStr = today.toISOString().split("T")[0];
const tomorrowStr = tomorrow.toISOString().split("T")[0];

// Format date as DD.MM.YYYY HH:mm
const formatDateDisplay = (dateStr) => {
  if (!dateStr) return "";

  // Handle ISO date string with time component (containing 'T')
  if (dateStr.includes("T")) {
    try {
      const date = new Date(dateStr);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${day}.${month}.${year} ${hours}:${minutes}`;
    } catch (e) {
      console.error("Date parsing error:", e);
    }
  }

  // Handle YYYY-MM-DD format
  const parts = dateStr.split("-");
  if (parts.length === 3) {
    return `${parts[2]}.${parts[1]}.${parts[0]} 00:00`;
  }

  return dateStr; // Return as is if format is not recognized
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

class BonusCampaignSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabValue: 0,
      bonusRanges: [],
      expanded: true,
      expandedRows: new Set(),
    };
  }

  componentDidMount() {
    const { fetchCampaigns, fetchRegions, updateForm } = this.props;

    updateForm("startDate", todayStr);
    updateForm("endDate", tomorrowStr);
    updateForm("bonusRanges", []);

    fetchCampaigns();
    fetchRegions();
  }

  handleInputChange = (field) => (event) => {
    const { updateForm } = this.props;
    const value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    updateForm(field, value);
  };

  handleRegionChange = (event) => {
    const { updateForm } = this.props;
    updateForm("selectedRegions", event.target.value);
  };

  handleDateChange = (field) => (date) => {
    if (date) {
      // Format as YYYY-MM-DD HH:mm with proper timezone handling
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const dateStr = `${year}-${month}-${day}T${hours}:${minutes}:00`;
      this.props.updateForm(field, dateStr);
    }
  };

  handleBonusRangeChange = (index, field) => (event) => {
    const { formData, updateForm } = this.props;
    const currentBonusRanges = [...(formData.bonusRanges || [])];

    currentBonusRanges[index] = {
      ...currentBonusRanges[index],
      [field]: event.target.value,
    };

    updateForm("bonusRanges", currentBonusRanges);
  };

  handleAddBonusRange = () => {
    const { formData, updateForm } = this.props;
    const currentBonusRanges = formData.bonusRanges || [];

    // Get the last range's end value if exists
    const lastRange = currentBonusRanges[currentBonusRanges.length - 1];
    let newStartValue = "0";

    if (lastRange && lastRange.endValue) {
      // Parse the last end value and add 1
      const lastEndValue = parseInt(lastRange.endValue);
      if (!isNaN(lastEndValue)) {
        newStartValue = (lastEndValue + 1).toString();
      }
    }

    const updatedBonusRanges = [
      ...currentBonusRanges,
      {
        startValue: newStartValue,
        endValue: "",
        bonusAmount: "",
      },
    ];

    updateForm("bonusRanges", updatedBonusRanges);
    // Ensure accordion is expanded when adding new range
    this.setState({ expanded: true });
  };

  handleRemoveBonusRange = (index) => () => {
    const { formData, updateForm } = this.props;
    const currentBonusRanges = [...(formData.bonusRanges || [])];
    currentBonusRanges.splice(index, 1);
    updateForm("bonusRanges", currentBonusRanges);
  };

  handleAddCampaign = () => {
    const { addCampaign, formData, resetForm } = this.props;
    const paketYoldaId = cookie.load("PaketYoldaId");

    // Prepare bonus ranges
    const bonusRanges = (formData.bonusRanges || []).map((range) => ({
      StartingValue: parseInt(range.startValue),
      EndValue: parseInt(range.endValue),
      BonusAmount: parseFloat(range.bonusAmount),
    }));

    // Prepare main campaign data
    const campaignData = {
      Id: "00000000-0000-0000-0000-000000000000",
      RuleName: formData.ruleName,
      StartDate: formData.startDate,
      EndDate: formData.endDate,
      Status: formData.isActive ? 0 : 1,
      Regions: formData.selectedRegions || [],
      BrandId: paketYoldaId || "",
      BonusRanges: bonusRanges,
    };

    addCampaign(campaignData);
    resetForm();

    // Reset dates after form reset
    setTimeout(() => {
      this.props.updateForm("startDate", todayStr);
      this.props.updateForm("endDate", tomorrowStr);
    }, 100);
  };

  handleTabChange = (event, newValue) => {
    this.setState({ tabValue: newValue });
  };

  parseDate = (dateStr) => {
    if (!dateStr) return null;

    if (dateStr.includes("T")) {
      try {
        return new Date(dateStr);
      } catch (e) {
        console.error("Date parsing error:", e);
        return null;
      }
    }

    const parts = dateStr.split("-");
    if (parts.length === 3) {
      return new Date(
        parseInt(parts[0]),
        parseInt(parts[1]) - 1,
        parseInt(parts[2])
      );
    }

    return null;
  };

  handleRowClick = (campaignId) => {
    this.setState((prevState) => {
      const expandedRows = new Set(prevState.expandedRows);
      if (expandedRows.has(campaignId)) {
        expandedRows.delete(campaignId);
      } else {
        expandedRows.add(campaignId);
      }
      return { expandedRows };
    });
  };

  isFormValid = () => {
    const { formData } = this.props;
    const bonusRanges = formData.bonusRanges || [];

    // Check if required fields are filled
    if (!formData.ruleName || !formData.startDate || !formData.endDate) {
      return false;
    }

    // Check if there are any bonus ranges
    if (bonusRanges.length === 0) {
      return false;
    }

    // Check if all bonus ranges are properly filled
    const isAllRangesFilled = bonusRanges.every(
      (range) =>
        range.startValue !== "" &&
        range.endValue !== "" &&
        range.bonusAmount !== "" &&
        !isNaN(parseInt(range.startValue)) &&
        !isNaN(parseInt(range.endValue)) &&
        !isNaN(parseFloat(range.bonusAmount))
    );

    return isAllRangesFilled;
  };

  isStartDateInFuture = (startDate) => {
    if (!startDate) return false;
    const now = new Date();
    const campaignStart = new Date(startDate);
    return campaignStart > now;
  };

  handleDeleteCampaign = (campaignId) => {
    const campaign = this.props.campaigns.find((c) => c.Id === campaignId);

    if (!this.isStartDateInFuture(campaign?.StartDate)) {
      return; // Early return if start date has passed
    }

    if (window.confirm("Bu bonus kuralını silmek istediğinize emin misiniz?")) {
      this.props.deleteCampaign(campaignId);
    }
  };

  handleEditCampaign = (campaign) => {
    const { updateForm } = this.props;
    // Form verilerini seçilen kampanya ile doldur
    updateForm("ruleName", campaign.RuleName);
    updateForm("startDate", campaign.StartDate);
    updateForm("endDate", campaign.EndDate);
    updateForm("isActive", campaign.Status === 1);
    updateForm("selectedRegions", campaign.Regions || []);
    updateForm(
      "bonusRanges",
      campaign.BonusRanges?.map((range) => ({
        startValue: range.StartingValue.toString(),
        endValue: range.EndValue.toString(),
        bonusAmount: range.BonusAmount.toString(),
      })) || []
    );

    // Scroll to top
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  handleToggleStatus = (campaignId, event) => {
    event.stopPropagation();
    this.props.toggleStatus(campaignId);
  };

  handleRestoreCampaign = (campaignId) => {
    const campaign = this.props.campaigns.find((c) => c.Id === campaignId);

    if (!this.isStartDateInFuture(campaign?.StartDate)) {
      return; // Early return if start date has passed
    }

    if (
      window.confirm("Bu bonus kuralını geri almak istediğinize emin misiniz?")
    ) {
      this.props.deleteCampaign(campaignId);
    }
  };

  renderRulesTable = (rules) => {
    const { regions } = this.props;
    const { expandedRows } = this.state;

    return (
      <Table style={{ backgroundColor: "transparent" }}>
        <TableHead>
          <TableRow>
            <TableCell
              style={{
                fontWeight: "bold",
                borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
              }}
            >
              Kural Adı
            </TableCell>
            <TableCell
              style={{
                fontWeight: "bold",
                borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
              }}
            >
              Başlangıç Tarihi
            </TableCell>
            <TableCell
              style={{
                fontWeight: "bold",
                borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
              }}
            >
              Bitiş Tarihi
            </TableCell>
            <TableCell
              style={{
                fontWeight: "bold",
                borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
              }}
            >
              Bölgeler
            </TableCell>
            <TableCell
              style={{
                fontWeight: "bold",
                borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
              }}
            >
              Oluşturulma Tarihi
            </TableCell>
            <TableCell
              style={{
                fontWeight: "bold",
                borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
              }}
            >
              Durum
            </TableCell>
            <TableCell
              style={{
                fontWeight: "bold",
                borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
              }}
            >
              İşlemler
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rules.map((campaign) => (
            <React.Fragment key={campaign.Id}>
              <TableRow
                onClick={() => this.handleRowClick(campaign.Id)}
                style={{
                  cursor: "pointer",
                  backgroundColor: expandedRows.has(campaign.Id)
                    ? "rgba(255, 255, 255, 0.04)"
                    : "transparent",
                }}
                hover
              >
                <TableCell
                  style={{
                    borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Icon
                      style={{
                        marginRight: 8,
                        transform: expandedRows.has(campaign.Id)
                          ? "rotate(90deg)"
                          : "none",
                        transition: "transform 0.3s",
                        color: "inherit",
                      }}
                    >
                      chevron_right
                    </Icon>
                    {campaign.RuleName}
                  </div>
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
                  }}
                >
                  {formatDateDisplay(campaign.StartDate)}
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
                  }}
                >
                  {formatDateDisplay(campaign.EndDate)}
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
                  }}
                >
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                    {campaign.Regions &&
                      campaign.Regions.map((regionId) => {
                        const region = regions.find((r) => r.Id === regionId);
                        return (
                          <Chip
                            key={regionId}
                            label={region ? region.RegionName : regionId}
                            size="small"
                            style={{
                              backgroundColor: "rgba(255, 255, 255, 0.08)",
                            }}
                          />
                        );
                      })}
                  </div>
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
                  }}
                >
                  {formatDateDisplay(campaign.CreationTime)}
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Switch
                        checked={campaign.Status === 0}
                        onChange={(e) =>
                          this.handleToggleStatus(campaign.Id, e)
                        }
                        color="primary"
                        disabled={campaign.Status === 2}
                      />
                    }
                    label={
                      campaign.Status === 0
                        ? "Aktif"
                        : campaign.Status === 1
                          ? "Pasif"
                          : "Silinmiş"
                    }
                    onClick={(e) => e.stopPropagation()}
                  />
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
                  }}
                >
                  <div style={{ display: "flex", gap: 8 }}>
                    {campaign.Status === 2 ? (
                      // Restore button for deleted campaigns - only if start date is in future
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          this.handleRestoreCampaign(campaign.Id);
                        }}
                        style={{
                          color: "#27ae60",
                          backgroundColor: "rgba(39, 174, 96, 0.08)",
                          opacity: this.isStartDateInFuture(campaign.StartDate)
                            ? 1
                            : 0.5,
                        }}
                        disabled={!this.isStartDateInFuture(campaign.StartDate)}
                        title={
                          !this.isStartDateInFuture(campaign.StartDate)
                            ? "Başlangıç tarihi geçmiş kampanyalar geri alınamaz"
                            : "Kampanyayı geri al"
                        }
                      >
                        <Icon>restore</Icon>
                      </IconButton>
                    ) : (
                      // Edit and Delete buttons for active/passive campaigns
                      <>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            this.handleEditCampaign(campaign);
                          }}
                          style={{
                            color: "inherit",
                            backgroundColor: "rgba(255, 255, 255, 0.08)",
                          }}
                        >
                          <Icon>edit</Icon>
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            this.handleDeleteCampaign(campaign.Id);
                          }}
                          style={{
                            color: "#e74c3c",
                            backgroundColor: "rgba(231, 76, 60, 0.08)",
                            opacity: this.isStartDateInFuture(
                              campaign.StartDate
                            )
                              ? 1
                              : 0.5,
                          }}
                          disabled={
                            !this.isStartDateInFuture(campaign.StartDate)
                          }
                          title={
                            !this.isStartDateInFuture(campaign.StartDate)
                              ? "Başlangıç tarihi geçmiş kampanyalar silinemez"
                              : "Kampanyayı sil"
                          }
                        >
                          <Icon>delete</Icon>
                        </IconButton>
                      </>
                    )}
                  </div>
                </TableCell>
              </TableRow>
              {expandedRows.has(campaign.Id) && (
                <TableRow>
                  <TableCell
                    colSpan={6}
                    style={{
                      padding: "16px 32px",
                      backgroundColor: "rgba(255, 255, 255, 0.02)",
                      borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      gutterBottom
                      style={{ marginBottom: 16, color: "inherit" }}
                    >
                      Bonus Aralıkları
                    </Typography>
                    <Table
                      size="small"
                      style={{ backgroundColor: "transparent" }}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell
                            style={{
                              fontWeight: 500,
                              borderBottom:
                                "1px solid rgba(255, 255, 255, 0.12)",
                            }}
                          >
                            Başlangıç Değeri
                          </TableCell>
                          <TableCell
                            style={{
                              fontWeight: 500,
                              borderBottom:
                                "1px solid rgba(255, 255, 255, 0.12)",
                            }}
                          >
                            Bitiş Değeri
                          </TableCell>
                          <TableCell
                            style={{
                              fontWeight: 500,
                              borderBottom:
                                "1px solid rgba(255, 255, 255, 0.12)",
                            }}
                          >
                            Paket Başı Tutar (₺)
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {Array.isArray(campaign.BonusRanges) &&
                        campaign.BonusRanges.length > 0 ? (
                          [...campaign.BonusRanges]
                            .sort((a, b) => a.StartingValue - b.StartingValue)
                            .map((range, index) => (
                              <TableRow key={index}>
                                <TableCell
                                  style={{
                                    borderBottom:
                                      "1px solid rgba(255, 255, 255, 0.12)",
                                  }}
                                >
                                  {range.StartingValue}
                                </TableCell>
                                <TableCell
                                  style={{
                                    borderBottom:
                                      "1px solid rgba(255, 255, 255, 0.12)",
                                  }}
                                >
                                  {range.EndValue}
                                </TableCell>
                                <TableCell
                                  style={{
                                    borderBottom:
                                      "1px solid rgba(255, 255, 255, 0.12)",
                                  }}
                                >
                                  {Number(range.BonusAmount).toFixed(2)}
                                </TableCell>
                              </TableRow>
                            ))
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={3}
                              align="center"
                              style={{
                                borderBottom:
                                  "1px solid rgba(255, 255, 255, 0.12)",
                              }}
                            >
                              Bonus aralığı bulunmamaktadır
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableCell>
                </TableRow>
              )}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    );
  };

  render() {
    const {
      classes,
      paketYoldaSettingsMenu,
      campaigns,
      formData,
      loading,
      regions,
    } = this.props;
    const { tabValue, expanded } = this.state;
    const bonusRanges = formData.bonusRanges || [];

    const activeCampaigns = campaigns.filter(
      (campaign) => campaign.Status === 0
    );
    const passiveCampaigns = campaigns.filter(
      (campaign) => campaign.Status === 1
    );
    const deletedCampaigns = campaigns.filter(
      (campaign) => campaign.Status === 2
    );

    return (
      <div
        style={{
          display:
            paketYoldaSettingsMenu === "BonusCampaignSettings"
              ? "block"
              : "none",
          padding: 20,
          height: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          position: "relative",
          minHeight: "calc(100vh - 100px)",
        }}
      >
        <Card className={classes.card} style={{ marginBottom: 20 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Bonus Kampanya Ayarları
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Kural Adı"
                  value={formData.ruleName || ""}
                  onChange={this.handleInputChange("ruleName")}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  style={{
                    marginBottom: 6,
                    padding: 0,
                    fontSize: 12,
                    fontFamily: "Quicksand,sans-serif",
                    lineHeight: 1,
                  }}
                >
                  Başlangıç Tarihi
                </Typography>
                <DatePicker
                  selected={this.parseDate(formData.startDate)}
                  onChange={this.handleDateChange("startDate")}
                  dateFormat="dd.MM.yyyy HH:mm"
                  locale="tr"
                  className="inputDate"
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  timeCaption="Saat"
                  minDate={new Date()}
                  minTime={new Date().setHours(0, 0, 0, 0)}
                  maxTime={new Date().setHours(23, 45, 0, 0)}
                  placeholderText="Başlangıç tarihi seçin"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  style={{
                    marginBottom: 6,
                    padding: 0,
                    fontSize: 12,
                    fontFamily: "Quicksand,sans-serif",
                    lineHeight: 1,
                  }}
                >
                  Bitiş Tarihi
                </Typography>
                <DatePicker
                  selected={this.parseDate(formData.endDate)}
                  onChange={this.handleDateChange("endDate")}
                  dateFormat="dd.MM.yyyy HH:mm"
                  locale="tr"
                  className="inputDate"
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  timeCaption="Saat"
                  minDate={this.parseDate(formData.startDate) || new Date()}
                  minTime={
                    this.parseDate(formData.startDate)?.getDate() ===
                    new Date().getDate()
                      ? new Date().setHours(
                          new Date().getHours(),
                          new Date().getMinutes(),
                          0,
                          0
                        )
                      : new Date().setHours(0, 0, 0, 0)
                  }
                  maxTime={new Date().setHours(23, 45, 0, 0)}
                  placeholderText="Bitiş tarihi seçin"
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="region-select-label">Bölgeler</InputLabel>
                  <Select
                    labelId="region-select-label"
                    id="region-select"
                    multiple
                    value={formData.selectedRegions || []}
                    onChange={this.handleRegionChange}
                    label="Bölgeler"
                    renderValue={(selected) => (
                      <div
                        style={{ display: "flex", flexWrap: "wrap", gap: 4 }}
                      >
                        {selected.map((value) => {
                          const region = regions.find((r) => r.Id === value);
                          return (
                            <Chip
                              key={value}
                              label={region ? region.RegionName : value}
                              size="small"
                            />
                          );
                        })}
                      </div>
                    )}
                    MenuProps={MenuProps}
                  >
                    {regions.map((region) => (
                      <MenuItem key={region.Id} value={region.Id}>
                        {region.RegionName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={formData.isActive || false}
                      onChange={this.handleInputChange("isActive")}
                      color="primary"
                    />
                  }
                  label="Aktif"
                />
              </Grid>

              <Grid item xs={12}>
                <Accordion
                  expanded={expanded}
                  onChange={() =>
                    this.setState((prevState) => ({
                      expanded: !prevState.expanded,
                    }))
                  }
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="bonus-ranges-content"
                    id="bonus-ranges-header"
                  >
                    <Typography>
                      Bonus Aralıkları ({bonusRanges.length})
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      {bonusRanges.map((range, index) => (
                        <Grid item xs={12} key={index}>
                          <Card
                            variant="outlined"
                            style={{ backgroundColor: "transparent" }}
                          >
                            <CardContent>
                              <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} sm={3}>
                                  <TextField
                                    fullWidth
                                    label="Başlangıç Paket Sayısı (Adet)"
                                    type="number"
                                    value={range.startValue}
                                    onChange={this.handleBonusRangeChange(
                                      index,
                                      "startValue"
                                    )}
                                    variant="outlined"
                                    size="small"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                  <TextField
                                    fullWidth
                                    label="Bitiş Paket Sayısı (Adet)"
                                    type="number"
                                    value={range.endValue}
                                    onChange={this.handleBonusRangeChange(
                                      index,
                                      "endValue"
                                    )}
                                    variant="outlined"
                                    size="small"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                  <TextField
                                    fullWidth
                                    label="Bonus Miktarı (₺/Paket)"
                                    type="number"
                                    value={range.bonusAmount}
                                    onChange={this.handleBonusRangeChange(
                                      index,
                                      "bonusAmount"
                                    )}
                                    variant="outlined"
                                    size="small"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                  <IconButton
                                    aria-label="delete"
                                    onClick={this.handleRemoveBonusRange(index)}
                                    size="small"
                                    style={{ color: "inherit" }}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </Grid>
                              </Grid>
                            </CardContent>
                          </Card>
                        </Grid>
                      ))}
                      <Grid item xs={12}>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={this.handleAddBonusRange}
                          startIcon={<Icon>add</Icon>}
                          fullWidth
                        >
                          Yeni Bonus Aralığı Ekle
                        </Button>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </Grid>

              <Grid item xs={12} style={{ marginTop: 16 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handleAddCampaign}
                  startIcon={<Icon>add</Icon>}
                  disabled={loading || !this.isFormValid()}
                >
                  Bonus Kampanyası Oluştur
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <Card className={classes.card}>
          <CardContent>
            <Typography variant="h6" gutterBottom style={{ marginBottom: 20 }}>
              Mevcut Bonus Kuralları
            </Typography>

            <Tabs
              value={tabValue}
              onChange={this.handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              style={{
                marginBottom: 20,
                borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
              }}
            >
              <Tab
                label={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span>Aktif Kurallar</span>
                    <Chip
                      label={activeCampaigns.length}
                      size="small"
                      style={{
                        marginLeft: 8,
                        backgroundColor: "#16a085",
                        color: "#fff",
                      }}
                    />
                  </div>
                }
              />
              <Tab
                label={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span>Pasif Kurallar</span>
                    <Chip
                      label={passiveCampaigns.length}
                      size="small"
                      style={{
                        marginLeft: 8,
                        backgroundColor: "#e74c3c",
                        color: "#fff",
                      }}
                    />
                  </div>
                }
              />
              <Tab
                label={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span>Silinen Kurallar</span>
                    <Chip
                      label={deletedCampaigns.length}
                      size="small"
                      style={{
                        marginLeft: 8,
                        backgroundColor: "#7f8c8d",
                        color: "#fff",
                      }}
                    />
                  </div>
                }
              />
            </Tabs>

            <TabPanel value={tabValue} index={0}>
              {this.renderRulesTable(activeCampaigns)}
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
              {this.renderRulesTable(passiveCampaigns)}
            </TabPanel>
            <TabPanel value={tabValue} index={2}>
              {this.renderRulesTable(deletedCampaigns)}
            </TabPanel>
          </CardContent>
        </Card>
      </div>
    );
  }
}

BonusCampaignSettings.propTypes = {
  classes: PropTypes.object.isRequired,
  paketYoldaSettingsMenu: PropTypes.string.isRequired,
  campaigns: PropTypes.array.isRequired,
  regions: PropTypes.array.isRequired,
  formData: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  fetchCampaigns: PropTypes.func.isRequired,
  fetchRegions: PropTypes.func.isRequired,
  addCampaign: PropTypes.func.isRequired,
  updateForm: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  toggleStatus: PropTypes.func.isRequired,
  deleteCampaign: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const bonusRuleState = state.get("BonusRuleReducer");
  let campaigns = bonusRuleState.campaigns || [];

  // Parse campaigns if they are in string format
  if (typeof campaigns === "string") {
    try {
      campaigns = JSON.parse(campaigns);
    } catch (e) {
      console.error("Error parsing campaigns:", e);
      campaigns = [];
    }
  }

  // Ensure campaigns is always an array
  if (!Array.isArray(campaigns)) {
    campaigns = [];
  }

  return {
    paketYoldaSettingsMenu: state.get("paketYoldaReducer")
      .paketYoldaSettingsMenu,
    campaigns: campaigns,
    regions: bonusRuleState.regions || [],
    formData: bonusRuleState.formData || {},
    loading: bonusRuleState.loading || false,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchCampaigns: () => dispatch(getBonusRules()),
  fetchRegions: () => dispatch(getRegionsList()),
  addCampaign: (data) => dispatch(setBonusRule(data)),
  updateForm: (field, value) => dispatch(updateFormData(field, value)),
  resetForm: () => dispatch(resetFormData()),
  toggleStatus: (id) => dispatch(toggleBonusRuleStatus(id)),
  deleteCampaign: (id) => dispatch(deleteBonusRule(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(injectIntl(BonusCampaignSettings)));
